import { Field, InjectedFormProps } from 'redux-form';

import { FileUpload } from 'dashboard/components/FormControls/FormControl';
import { FileWithPreview } from 'dashboard/components-lib/FileUpload/types';
import { FormAddListItemProps } from 'dashboard/forms/FormAddListItem/FormAddListItem';

const SelfieBackgroundFields = (props: InjectedFormProps<{}, FormAddListItemProps>) => {
  return (
    <Field
      component={FileUpload}
      accept={['image/png', 'image/jpeg']}
      label='Upload a selfie as a PNG or JPEG image.'
      labelDrag='Upload a selfie as a PNG or JPEG image.'
      onChange={((file?: FileWithPreview) => props.change('selfiePhoto', file?.preview)) as any}
      disabled={props.submitting}
      name='selfiePhoto'
      id='selfiePhoto'
    />
  );
};

export default SelfieBackgroundFields;
